
export const getCountryData = ():any[] => {
	const countryData = [
		{
			name: "Switzerland",
			dial_code: "+41",
			code: "CH"
		}
	]

	return countryData.map(country => {
		const dial_code_zero_temp = country.dial_code.split("")
		dial_code_zero_temp[0] = "0"
		const dial_code_zero = dial_code_zero_temp.join("")
		return {
			code: country.code,
			dial_code: country.dial_code,
			name: country.name,
			dial_code_zero,
			label: `${country.code} (${country.dial_code})`
		}
	})
}
